import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'postalCode',
})
export class PostalCodePipe implements PipeTransform {
  transform(postalCode?: string): string {
    if (!postalCode) {
      return '';
    }

    const cleaned = postalCode.replace(/\D/g, '');

    if (cleaned.length !== 8) {
      return postalCode;
    }

    return `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`;
  }
}
